module.exports = __webpack_public_path__ + "static/media/22.c7b2257b.png";